import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '@/modules/auth/AuthProvider';
import { AvatarProvider } from '@/core/context/avatar/AvatarContext';
import LibrasManager from '@/core/components/libras/LibrasManager';
import Routes from '@/routes/Routes';

const App = () => (
    <AuthProvider>
        <AvatarProvider>
            <LibrasManager />
            <Router>
                <Routes />
            </Router>
        </AvatarProvider>
    </AuthProvider>
);

export default App;
